import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PartyMeeting  {
    _originalTypeClassName = "zERP.BO.PartyMeeting";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PartyMeeting.translate = translateService;
}
this.ProceedingsFiles = [];
this.HRParty = new Domain.HRParty();
this.Topics = [];
this.MembersAttending = [];
this.Id = null;
this.Code = null;
this.Title = null;
this.Location = null;
this.Duration = null;
this.ProceedingsText = null;
this.Comments = null;
this.MeetingDate = null;
this.RequiresPhysicalAttendance = false;
this.Status = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Title:any;
Location:any;
Duration:any;
ProceedingsText:any;
Comments:any;
MeetingDate:any;
RequiresPhysicalAttendance:any;
Status:any;
ProceedingsFiles:any;
HRParty:any;
Topics:any;
MembersAttending:any;
static setProceedingsFiles = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProceedingsFiles == null) $this.ProceedingsFiles = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProceedingsFiles.length > 0) {
                    Domain.PartyMeeting.removeProceedingsFiles($this, $this.ProceedingsFiles[0]);
                }

                Domain.PartyMeeting.addManyProceedingsFiles($this, copyItems);
            }
static addManyProceedingsFiles = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PartyMeeting.addProceedingsFiles($this, items[i]);
                }
            }
static addProceedingsFiles = ($this, item) => {
                if ($this.ProceedingsFiles == null) $this.ProceedingsFiles = [];
                if (item == null || $this.ProceedingsFiles.indexOf(item) > -1) return;
                $this.ProceedingsFiles.push(item);
}
static addRangeProceedingsFiles = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PartyMeeting.addProceedingsFiles($this, item));
            }
static removeProceedingsFiles = ($this, item) => {
                if ($this == null || $this.ProceedingsFiles == null || $this.ProceedingsFiles.indexOf(item) === -1) return;
                var _index = $this.ProceedingsFiles.indexOf(item);
                $this.ProceedingsFiles.splice(_index, 1);
}
static clearProceedingsFiles = ($this) => { $this.ProceedingsFiles = null; }
static setHRParty = ($this, value) => {
var oldValue = $this.HRParty;
$this.HRParty = value;
if (value != null) {
if (oldValue != null && oldValue.Meeting != null) { oldValue.Meeting = null; }
if ($this.HRParty.Meeting !== $this) {
Domain.HRParty.setMeeting(value, $this);
}
}
}
static setTopics = ($this, items) => {
                if (items == null) items = [];
                if ($this.Topics == null) $this.Topics = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Topics.length > 0) {
                    Domain.PartyMeeting.removeTopics($this, $this.Topics[0]);
                }

                Domain.PartyMeeting.addManyTopics($this, copyItems);
            }
static addManyTopics = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PartyMeeting.addTopics($this, items[i]);
                }
            }
static addTopics = ($this, item) => {
                if ($this.Topics == null) $this.Topics = [];
                if (item == null || $this.Topics.indexOf(item) > -1) return;
                $this.Topics.push(item);
}
static addRangeTopics = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PartyMeeting.addTopics($this, item));
            }
static removeTopics = ($this, item) => {
                if ($this == null || $this.Topics == null || $this.Topics.indexOf(item) === -1) return;
                var _index = $this.Topics.indexOf(item);
                $this.Topics.splice(_index, 1);
}
static clearTopics = ($this) => { $this.Topics = null; }
static setMembersAttending = ($this, items) => {
                if (items == null) items = [];
                if ($this.MembersAttending == null) $this.MembersAttending = [];

                const copyItems = Common.cloneObject(items);

                while ($this.MembersAttending.length > 0) {
                    Domain.PartyMeeting.removeMembersAttending($this, $this.MembersAttending[0]);
                }

                Domain.PartyMeeting.addManyMembersAttending($this, copyItems);
            }
static addManyMembersAttending = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PartyMeeting.addMembersAttending($this, items[i]);
                }
            }
static addMembersAttending = ($this, item) => {
                if ($this.MembersAttending == null) $this.MembersAttending = [];
                if (item == null || $this.MembersAttending.indexOf(item) > -1) return;
                $this.MembersAttending.push(item);
if (item.Meeting != $this) {
Domain.MemberAttendance.setMeeting(item, $this);
}
}
static addRangeMembersAttending = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PartyMeeting.addMembersAttending($this, item));
            }
static removeMembersAttending = ($this, item) => {
                if ($this == null || $this.MembersAttending == null || $this.MembersAttending.indexOf(item) === -1) return;
                var _index = $this.MembersAttending.indexOf(item);
                $this.MembersAttending.splice(_index, 1);
item.Meeting = null;
}
static clearMembersAttending = ($this) => { $this.MembersAttending = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}